<template>
    <el-main class="hs-container" ref="contractno-container">
        <div class="contractno-content">
            <div class="handle-box">
                <div class="handle-left">
                    <el-button type="primary" @click="$refs.editForm.showDrawer('')">添加</el-button>
                    <el-select class="ml8" v-model="query.company_id" clearable filterable placeholder="选择公司">
                        <el-option v-for="item in companyList" :key="item.id" :label="item.title" :value="item.id + ''"></el-option>
                    </el-select>
                    <el-input class="search-input ml8" v-model="query.contract_no" placeholder="合同号" clearable></el-input>
                    <el-button type="primary" @click="doSearch">查询</el-button>
                    <el-button type="primary" @click="download">导出</el-button>
                </div>
            </div>
            <div class="table-box">
                <el-table :data="tableData" ref="tableData" v-loading="loading" :height="tableHeight" :max-height="tableHeight" @sort-change="sortChange">
                    <el-table-column prop="id" label="编号" width="100"> </el-table-column>
                    <el-table-column prop="company.title" width="160" label="归属公司"> </el-table-column>
                    <el-table-column prop="contract_no" width="160" label="合同号"> </el-table-column>
                    <el-table-column prop="is_used" label="是否使用" sortable width="160" align="center"> </el-table-column>
                    <el-table-column prop="is_abrogated" label="是否作废" sortable width="160" align="center">
                        <template slot-scope="scope">
                            {{ scope.row.is_abrogated == 0 ? '未作废' : '已作废' }}
                        </template>
                    </el-table-column>
                    <el-table-column prop="order.hotel_text" show-overflow-tooltip label="签单酒店" align="center"> </el-table-column>
                    <el-table-column prop="order.create_time" label="进场时间" align="center"> </el-table-column>
                    <el-table-column label="操作" width="200">
                        <template slot-scope="scope">
                            <el-button-group>
                                <el-button @click="$refs.editForm.showDrawer(scope.row)" type="primary" size="mini">编辑</el-button>
                                <el-button @click="abrogate(scope.$index, scope.row)" :disabled="scope.row.is_abrogated == 1" type="warning" size="mini">作废</el-button>
                                <el-button @click="deleteFn(scope.$index, scope.row)" type="danger" size="mini">删除</el-button>
                            </el-button-group>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="footer-box">
                <div class="download"></div>
                <div class="pagination">
                    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pagination.page" :page-sizes="[14, 20, 30, 50]" :page-size="pagination.limit" layout="total, sizes, prev, pager, next, jumper" :total="pagination.total">
                    </el-pagination>
                </div>
            </div>
        </div>

        <editForm ref="editForm" @getTableData="getTableData" @showLog="showLog"></editForm>
        <batchLogDialog ref="batchLogDialog"></batchLogDialog>
    </el-main>
</template>

<script>
import dictionary from '@/utils/dictionary';

import editForm from './edit';
import batchLogDialog from './log';
const query = {
    company_id: '',
    contract_no: ''
}
export default {
    components: {
        editForm,
        batchLogDialog
    },
    data() {
        let tableHeight = window.innerHeight - 252;
        let windowheight = window.innerHeight;
        return {
            query: Object.assign({}, query),
            loading: false,
            tableData: [],
            tableHeight: windowheight,
            pagination: {
                page: 1,
                limit: 14,
                total: 0
            }
        };
    },
    created() {
        this.getTableData();
    },
    beforeMount() {
        this.dictionary = dictionary;
    },
    mounted() {
        this.$nextTick(() => {
            this.tableHeight = window.innerHeight - 224;
        });
    },
    computed: {
        companyList: function () {
            return dictionary.getPicker('company');
        },

    },
    methods: {
        getTableData() {
            //获取表格列表
            let that = this;
            let url = '/api/order.contract_no/index';
            let query = this.query;
            query.pagination = this.pagination;
            this.loading = true;
            this.$post(url, query).then(function (response) {
                let result = response.data;
                that.tableData = result.list;
                that.pagination = result.pagination;
                that.loading = false;
            });
        },
        doSearch() {
            // 搜索
            this.pagination.page = 1;
            this.getTableData();
        },
        handleSizeChange(val) {
            this.pagination.limit = val;
            this.getTableData();
        },
        handleCurrentChange(val) {
            this.pagination.page = val;
            this.getTableData();
        },

        // 作废
        abrogate(index, e) {
            let _this = this;
            this.$confirm('是否确认作废?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            })
                .then(() => {
                    let url = '/api/order.contract_no/doAbrogate';
                    let query = {
                        id: e.id
                    };
                    _this.loading = true;
                    this.$post(url, query).then(function (response) {
                        if (response.code == 200) {
                            _this.getTableData();
                            _this.$message.success(response.msg);
                            _this.loading = false;
                        } else {
                            _this.$message.error(response.msg);
                            _this.loading = false;
                        }
                    });
                })
                .catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消'
                    });
                });
        },
        // 排序
        sortChange(e) {
            if (e.order) {
                let sort = {};
                sort.field = e.prop;
                sort.order = e.order == 'descending' ? 'desc' : 'asc';
                this.sort = sort;
            } else {
                this.sort = {};
            }
            this.getTableData();
        },
        deleteFn(index, e) {
            let _this = this;
            this.$confirm('此操作将, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            })
                .then(() => {
                    let url = '/api/order.contract_no/delete';
                    let query = {
                        id: e.id
                    };
                    this.loading = true;
                    this.$post(url, query).then(function (response) {
                        if (response.code == 200) {
                            _this.getTableData();
                            _this.$message.success(response.msg);
                            _this.loading = false;
                        } else {
                            _this.$message.error(response.msg);
                            _this.loading = false;
                        }
                    });
                })
                .catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消'
                    });
                });
        },
        showLog(batchNo) {
            this.$refs['batchLogDialog'].getTableData(batchNo);
        },
        download() {
            let that = this;
            let url = '/api/order.contract_no/download';
            let query = that.query;
            that.loading = true;
            this.$post(url, query, {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded' //请求的数据类型为form data格式
                },
                responseType: 'blob' //设置响应的数据类型为一个包含二进制数据的 Blob 对象，必须设置！！！
            })
                .then(function (res) {
                    let blob = new Blob([res], {
                        type: 'application/vnd.ms-excel,charset=utf-8'
                    });
                    let url = window.URL.createObjectURL(blob); //创建下载链接
                    let link = document.createElement('a');
                    link.download = '订单号.csv'; //下载后的文件名
                    link.href = url;
                    link.click();
                    that.loading = false;
                })
                .catch(err => {
                    that.$message.error('下载失败，请稍后再试');
                });
        }
    }
};
</script>

<style lang="less">
@import url('@/assets/css/common.less');
</style>
